import { useTranslation } from 'react-i18next'
import contentData from '../data/content.json'
import RichText from '../components/ui/RichText'

function About() {
  const { t } = useTranslation()

  return (
    <div className="w-full">
      {/* Bio Section */}
      <section className="section-container py-40 px-20 tablet:px-32">
        <div className="content-wrapper">
          <h2 className="text-lato-bold text-[32px] mb-32">
            {t('pages.about.sections.bio.heading')}
          </h2>
          <div className="flex flex-col desktop:flex-row gap-40 desktop:gap-60 items-start">
            {/* Text */}
            <div className="flex-1">
              <RichText
                text={t('pages.about.sections.bio.text')}
                className="text-lato-regular"
              />
            </div>

            {/* Photo */}
            <div className="flex-shrink-0 w-full desktop:w-[380px]">
              <img
                src={contentData.images.nuriaAbout.url}
                alt={contentData.images.nuriaAbout.alt}
                className="w-full h-auto max-h-[600px] object-cover rounded-md"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Certifications */}
      <section className="section-container py-40 px-20 desktop:px-32">
        <div className="flex justify-center items-center gap-20 max-w-lg mx-auto">
          {contentData.images.certifications.map((cert, index) => (
            <div key={index} className="flex-1">
              <img
                src={cert.url}
                alt={cert.alt}
                className="w-full h-[120px] object-contain"
              />
            </div>
          ))}
        </div>
      </section>
    </div>
  )
}

export default About
